import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import SidebarItem from "./SidebarItem";
import ConnectBar from "./ConnectBar";
import ReferralBar from "./ReferralBar";
import Settings from "./Settings";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShuffle, faHandHoldingDollar, faHome, faMinus, faSackDollar, faUsd, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import AccountInfo from "./AccountInfo";
import UpgradeModal from "./UpgradeModal";
import { formatCurrency, getRate } from '../utils/currencyUtils';
import feather from 'feather-icons';
import { Link } from "react-router-dom"

function Sidebar({title, isOpen, toggleSidebar, toggleSettingsBar, settingsBar }) {
  const currentPath = window.location.pathname;
  useEffect(() => {
    feather.replace();
  }, []);
  const { user } = useUser();
  const [referralBar, setReferralBar] = useState(false);
  const [connectBar, setConnectBar] = useState(false);
  const toggleReferralBar = () => {
    setReferralBar(!referralBar);
  };
  const toggleConnectBar = () => {
    setConnectBar(!connectBar);
  };
  useEffect(() => {
    if (window.innerWidth >= 768 && !isOpen) {
      toggleSidebar();
    }
  }, [isOpen]);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const [crypto, setCrypto] = useState([]);
    const [fiat, setFiat] = useState([]);
    const [stock, setStock] = useState([]);
    const [wallet, setWallet] = useState([]);
    const [assetBal, setAssetBal] = useState(0);
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchwallet: true })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setWallet(data.wallet);
        }
      })
      .catch(err => {
        
      })
    }, [user]);
    useEffect(() => {
        fetch(`/coin_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
            id: index + 1,
            logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
            name: coin.name,
            type: 'crypto',
            symbol: coin.symbol,
            price: Number(coin.quote.USD.price.toFixed(2)),
            amount: 0,
        }));
        setCrypto(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
      fetch(`/stock_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      const stockList = Object.values(data);
      const updatedData = stockList.map((stock, index) => ({
          id: index + 1,
          logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
          name: stock.name,
          type: 'stock',
          symbol: stock.symbol,
          price: Number(stock.price.toFixed(2)),
          amount: 0,
      }));
      setStock(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {   
        fetch(`/fiat_list.txt`)
        .then((res) => res.json())
        .then((data) => {
          const wantedCurrencies = {
            AUD: 'Australian Dollar',
            CAD: 'Canadian Dollar',
            CHF: 'Swiss Franc',
            CNY: 'Chinese Yuan',
            EUR: 'Euro',
            GBP: 'British Pound',
            INR: 'Indian Rupee',
            JPY: 'Japanese Yen',
            RUB: 'Russian Ruble',
            USD: 'US Dollar',
            ZAR: 'South African Rand'
          };
          const fiatList = Object.entries(data)
            .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
            .map(([code, value], index) => ({
              id: index + 1,
              symbol: code,
              name: wantedCurrencies[code],
              price: Number(value),
              type: 'fiat',
              logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
              amount: 0,
            }));
          
          setFiat(fiatList);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
      if (!crypto.length && !fiat.length && !stock.length) return;
      const walletMap = wallet.reduce((acc, item) => {
        const key = item.coinName?.trim().toLowerCase();
        acc[key] = parseFloat(item.balance) || 0;
        return acc;
      }, {});
      let total = 0;
      let cryptoTotal = 0;
      let fiatTotal = 0;
      let stockTotal = 0;
      const applyWalletBalance = (list) => {
        let categorySum = 0;
        const result = list.map(item => {
          const key = item.name?.trim().toLowerCase();
          const matchedBalance = walletMap[key];
          const amount = matchedBalance || 0;
          const value = amount * item.price;
          categorySum += value;
          return {
            ...item,
            amount: matchedBalance || 0
          };
        });
        return { result, categorySum };
      };
      const { result: cryptoWithBalance, categorySum: cryptoSum } = applyWalletBalance(crypto);
      const { result: fiatWithBalance, categorySum: fiatSum } = applyWalletBalance(fiat);
      const { result: stockWithBalance, categorySum: stockSum } = applyWalletBalance(stock);
      cryptoTotal = cryptoSum;
      fiatTotal = fiatSum;
      stockTotal = stockSum;
      total = cryptoTotal + fiatTotal + stockTotal;
      const merged = [
        ...cryptoWithBalance,
        ...fiatWithBalance,
        ...stockWithBalance
      ];
      const sorted = merged.sort((a, b) => {
        if (b.amount > 0 && a.amount === 0) return 1;
        if (a.amount > 0 && b.amount === 0) return -1;
        return a.name.localeCompare(b.name);
      });
      setAssetBal(total);
    }, [crypto, fiat, stock, wallet]);
    const logout = () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/logout.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ logout: true})
      })
      .then(response => response.text())
      .then(data => {
        if (data === "success") {
          window.location.href = "login";
        }
      })
      .catch(err => {
        console.error(err)
      }) 
    };
    return (
      <>
        <div className={`col-auto sidebar ${window.innerWidth < 768 ? "mobilesidebar" : ""} ${isOpen ? "active" : ""}`}style={{ display: "block" }}>
          <img src={logo} alt="logo" className="app-logo mb-3" style={{paddingLeft:'16px',paddingRight:'16px'}}/>
          <div className="d-flex align-items-center justify-content-center rounded-circle position-absolute d-block d-md-none" style={{width:'30px',height:'30px', top:'15px',right:'20px',backgroundColor:'#ffffff0d'}} onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>
          </div>
          <div className="py-3 w-100" style={{backgroundColor:'#0a0b0c', paddingLeft:'16px',paddingRight:'16px'}}>
            <p className="text-secondary fw-semibold mb-0" style={{fontSize:'12px'}}>MAIN ACCOUNT BALANCE</p>
            <div className="d-flex align-items-top justify-content-between">
              <div>
                <div className="d-flex align-items-end">
                  <p className="fs-2 fw-semibold text-prime mb-0 lh-1">{formatCurrency(assetBal * rate)}</p>
                  <p className="fs-6 ms-3 text-white fw-semibold mb-0">{user?.currency}</p>
                </div>
                <p className="mb-0 fw-semibold text-white" style={{fontSize:'14px'}}>{formatCurrency(assetBal * rate)} {user?.currency}</p>
              </div>
              <i data-feather="log-out" className="text-prime" style={{cursor:'pointer'}} width="20" onClick={logout}></i>
            </div>  
            <hr/>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Profit (All)</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.profit * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Total Deposits</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.total_deposit * rate)}</span> {user?.currency}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="text-secondary mb-0" style={{fontSize:'14px'}}>Total Withdraws</p>
              <p className="fw-semibold mb-0" style={{fontSize:'14px'}}><span className="text-prime">{formatCurrency(user?.total_withdraw * rate)}</span> {user?.currency}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-3">
              <Link to="/deposit" className="py-2 d-flex justify-content-center rounded-pill" style={{border: '2px solid #ff6b35',backgroundColor:'transparent', textDecoration:'none',width:'47%'}}>
                <p className="mb-0 fw-semibold text-prime" style={{fontSize: '12px'}}>DEPOSIT</p>
              </Link>
              <Link to="/withdraw" className="d-flex justify-content-center rounded-pill bg-prime" style={{textDecoration:'none', paddingTop:'10px',paddingBottom:'10px',width:'47%'}}>
                <p className="mb-0 fw-semibold" style={{fontSize: '12px'}}>WITHDRAW</p>
              </Link>
            </div>
          </div>
          <div className="sidebar-navbar" style={{marginTop:'10px',paddingLeft:'16px',paddingRight:'16px'}}>
            <p className="mb-0 fw-bold text-white" style={{fontSize:'14px'}}>Account</p>
            <SidebarItem icon={<i data-feather="home" height="18"></i>} label="Dashboard" isActive={(title === "Dashboard")?true:false} link="/dashboard" />
            <SidebarItem icon={<i data-feather="credit-card" height="18"></i>} label="Deposit" isActive={(title === "Deposit")?true:false} link="/deposit" />
            <SidebarItem icon={<i data-feather="package" height="18"></i>} label="Withdraw" isActive={(title === "Withdraw")?true:false} link="/withdraw" />
            <SidebarItem icon={<i data-feather="send" height="18"></i>} label="Internal Transfer" isActive={(title === "Internal Transfer")?true:false} link="/transfer" />
            <SidebarItem icon={<i data-feather="grid" height="18"></i>} label="Assets" isActive={(title === "Assets")?true:false} link="/assets" />
            <SidebarItem icon={<FontAwesomeIcon icon={faShuffle} />} label="Swap" isActive={(title === "Swap")?true:false} link="/swap" />
            <SidebarItem icon={<i data-feather="slack" height="18"></i>} label="Markets" isActive={(title === "Markets")?true:false} link="/markets" />
            <p className="mb-0 fw-bold text-white mt-2" style={{fontSize:'14px'}}>Investment</p>
            <SidebarItem icon={<i data-feather="layers" height="18"></i>} label="Stock" isActive={(title === "Stock")?true:false} link="/stock" />
            {/* {user?.account_type == "401k" || user?.user_type == "adminface" && (
              <>
                <SidebarItem icon={<i data-feather="bar-chart" height="18"></i>} label="401k" isActive={title === "401k"} hasDropdown={true} 
                  dropdownItems={[
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>, 
                      label: "Retirement Savings", 
                      link: "/manager",
                      isActive: title === "Retirement Savings"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>, 
                      label: "Portfolio", 
                      link: "/portfolio",
                      isActive: title === "Portfolio"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>, 
                      label: "Contributions", 
                      link: "/contributions",
                      isActive: title === "Contributions"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>, 
                      label: "Performance", 
                      link: "/performance",
                      isActive: title === "Performance"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>,
                      label: "401(k) plans",
                      link: "/upgradeplan",
                      isActive: title === "401(k) plans"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>,
                      label: "Transactions",
                      link: "/transaction",
                      isActive: title === "Transactions"
                    },
                  ]}
                />
                <SidebarItem icon={<i data-feather="dollar-sign" height="18"></i>} label="Loan" isActive={title === "Loan"} hasDropdown={true} 
                  dropdownItems={[
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>,
                      label: "Loan", 
                      link: "/loan",
                      isActive: title === "Loan"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>,
                      label: "Get a Loan", 
                      link: "/getloan",
                      isActive: title === "Get a Loan"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>,
                      label: "Loan History", 
                      link: "/loanhistory",
                      isActive: title === "Loan History"
                    },
                    { 
                      icon: <FontAwesomeIcon icon={faMinus} style={{color: 'gray', cursor: 'pointer', fontSize: '22px'}}/>,
                      label: "Requirement", 
                      link: "/requirements",
                      isActive: title === "Requirement"
                    }
                  ]}
                />
              </>
            )} */}
            <SidebarItem icon={<i data-feather="activity" height="18"></i>} label="Trade" isActive={(title === "Trade")?true:false} link="/futures" />
            <SidebarItem icon={<i data-feather="database" height="18"></i>} label="Stake" isActive={(title === "Stake")?true:false} link="/stake" />
            <p className="mb-0 fw-bold text-white mt-2" style={{fontSize:'14px'}}>Trading</p>
            <SidebarItem icon={<i data-feather="hard-drive" height="18"></i>} label="Subscribe" isActive={(title === "Subscribe")?true:false} link="/subscribe" />
            <SidebarItem icon={<i data-feather="wifi" height="18"></i>} label="Signals" isActive={(title === "Signals")?true:false} link="/signal" />
            <SidebarItem icon={<i data-feather="copy" height="18"></i>} label="Copy Experts" isActive={(title === "Copy Experts")?true:false} link="/copyexpert" />
            <SidebarItem icon={<i data-feather="users" height="18"></i>} label="Referrals" isActive={(title === "Referrals")?true:false} onClick={() => {toggleReferralBar()}} />
            <p className="mb-0 fw-bold text-white mt-2" style={{fontSize:'14px'}}>Settings</p>
            <SidebarItem icon={<i data-feather="link" height="18"></i>} label="Connect wallet" isActive={(title === "Connect wallet")?true:false} onClick={() => {toggleConnectBar()}}  />
            <SidebarItem icon={<i data-feather="settings" height="18"></i>} label="Settings" isActive={(title === "Settings")?true:false} onClick={() => {toggleSettingsBar()}} />
            {user?.user_type === "adminface" && (
              <SidebarItem icon={<i data-feather="user-check" height="18"></i>} label="Manage" isActive={(title === "Manage")?true:false} link="/manage" />
            )}
          </div>
        </div>
        <UpgradeModal UserDetails={user} currentPath={currentPath} />
        <ReferralBar toggleReferralBar={toggleReferralBar} referralBar={referralBar}/>
        <ConnectBar toggleConnectBar={toggleConnectBar} connectBar={connectBar}/>
        <Settings toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
      </>
    )
}

export default Sidebar